// IoT API 版本配置
export const API_BASE = '/api/v1';
